// Colours
import { terracotta, emeraldGreen } from "../../../Constants/ColourConstants";

export const styles = {
  noPadding: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  formBox: {
    mt: 3,
    display: "flex",
    flexDirection: "column",
    gap: "4vh",
  },
  textFieldsBox: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  signupBtn: {
    borderRadius: 30,
    background: terracotta,
  },
  checkbox: {
    color: emeraldGreen,
    "&.Mui-checked": {
      color: emeraldGreen,
    },
  },
};
